// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"60ee0a8e","195":"bf23576b","453":"4fd4540b","577":"6243b9ea","895":"7e9996dc","917":"baeb8d13"}[chunkId] + ".chunk.js";
};